import { useState } from "react";
import styled, { css } from "styled-components";
import { Select } from "@beamcloud/design-system";
import { typography } from "screens/Homepage/components/typography";
import { PlanData } from "../OSS/data";
import {
  GetStartedWrapper,
  PlanName,
  PlanNameWrapper,
  PlanPrice,
  PlanPriceTag,
  PrimaryGetStartedButton,
  Table,
  TableCell,
  renderValue
} from "./styles";

const IndividualPlanTable: React.FC = () => {
  const [planIndex, setPlanIndex] = useState<number>(1);

  return (
    <Container>
      <ChangePlanWrapper>
        <ChangePlan>Change Plan</ChangePlan>
        <Select
          triggerWidth={126}
          minWidth={130}
          align="end"
          options={PlanData.plans.map((plan, index) => ({
            value: index,
            label: plan.type
          }))}
          value={planIndex}
          onChange={value => setPlanIndex(value as number)}
        />
      </ChangePlanWrapper>
      <Table>
        <thead>
          <tr>
            <TableCell colSpan={2} style={{ paddingLeft: "24px" }}>
              <PlanNameWrapper>
                <PlanName>{PlanData.plans[planIndex].type}</PlanName>
                <PlanPrice>{PlanData.plans[planIndex].price}</PlanPrice>
                <PlanPriceTag>Per month, plus usage</PlanPriceTag>
              </PlanNameWrapper>
            </TableCell>
          </tr>
        </thead>
        <tbody>
          <tr>
            <TableCell>Usage</TableCell>
            <TableCell></TableCell>
          </tr>
          {PlanData.usage.map((attr, index) => (
            <tr key={index}>
              <TableCell>{attr}</TableCell>
              <TableCell>{renderValue(PlanData.plans[planIndex].usage[index])}</TableCell>
            </tr>
          ))}
        </tbody>
        <tbody>
          <tr>
            <TableCell>Features</TableCell>
            <TableCell></TableCell>
          </tr>
          {PlanData.features.map((attr, index) => (
            <tr key={index}>
              <TableCell>{attr}</TableCell>
              <TableCell>{renderValue(PlanData.plans[planIndex].features[index])}</TableCell>
            </tr>
          ))}
        </tbody>
        <tbody>
          <tr>
            <TableCell>Support</TableCell>
            <TableCell></TableCell>
          </tr>
          {PlanData.support.map((attr, index) => (
            <tr key={index}>
              <TableCell>{attr}</TableCell>
              <TableCell>{renderValue(PlanData.plans[planIndex].support[index])}</TableCell>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <TableCell $isFooter={true} colSpan={2}>
              <GetStartedWrapper $isPrimary={true}>
                <PrimaryGetStartedButton href={PlanData.plans[planIndex].getStartedUrl}>
                  Get Started
                </PrimaryGetStartedButton>
                <p>Incl. 10h free usage credit</p>
              </GetStartedWrapper>
            </TableCell>
          </tr>
        </tfoot>
      </Table>
    </Container>
  );
};

export default IndividualPlanTable;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 32px;
  width: 100%;
`;

const ChangePlanWrapper = styled.div`
  ${({ theme }) => {
    return css`
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 12px 24px;
      box-sizing: border-box;
      gap: 10px;
      background-color: ${theme.colors.gray2};
      border: 1px solid ${theme.colors.gray6};
      border-radius: 8px;
      width: 100%;
    `;
  }}
`;

const ChangePlan = styled.p`
  ${({ theme }) => {
    return css`
      all: unset;
      flex-grow: 1;
      color: ${theme.colors.gray11};
      ${typography.textBaseLight};
    `;
  }}
`;
